// src/components/Cards.js
import React from 'react';
import './Machanedetail.css';
import servomot from '../../../imgs/servomot.webp';
import variablepum from '../../../imgs/variablepum.webp';
import Clampingsy from '../../../imgs/Clampingsy.webp';

const Machanedetail = () => {
  const data = [
    {
      title: '',
      description: `Servo Motor System
Comparing with the traditional hydraulic machine, S6 series can save more 50% of the power, energy saving is more obviously during pressure hold & cooling stage.`,
      image: servomot,
    },
    {
      title: '',
      description: `Variable Pump System
Perfect combination between computer and high efficient proportional plunger variable pump saves electricity by 25%-50%.`,
      image: variablepum,
    },
    {
      title: '',
      description: `Clamping System
Reliable and durable, Effective mold protection High repeatability of mold opening and closing.`,
      image: Clampingsy,
    },
  ];

  return (
    <div className="Machanedetail-wrapper">
      <h1 className="Machanedetail-heading">Machine Details</h1>
      <div className="Machaned-container">
        {data.map((item, index) => (
          <div className="Machaned"  data-aos="fade-down" key={index}>
            <img src={item.image} alt={item.title} className="card-img" />
            <h2 className="Machaned-title">{item.title}</h2>
            <p className="Machaned-desc">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Machanedetail;
